import {
  GET_ALL_LLM_SETTINGS,
  CREATE_LLM_SETTING,
  UPDATE_LLM_SETTING,
  DELETE_LLM_SETTING,
  ACTIVATE_LLM_SETTING,
  GET_LLM_PROVIDERS,
} from '../types'

const initialState = {
  llmSettings: [],
  providers: [],
}

const llmSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_LLM_SETTINGS:
      return { ...state, llmSettings: action.payload || [] }

    case GET_LLM_PROVIDERS:
      return { ...state, providers: action.payload || [] }

    case CREATE_LLM_SETTING:
      return {
        ...state,
        llmSettings: [...state.llmSettings, action.payload],
      }

    case UPDATE_LLM_SETTING:
      return {
        ...state,
        llmSettings: state.llmSettings.map((s) =>
          s.id === action.payload?.id ? action.payload : s,
        ),
      }

    case ACTIVATE_LLM_SETTING: {
      const activated = action.payload
      return {
        ...state,
        llmSettings: state.llmSettings.map((s) => ({
          ...s,
          isActive: s.id === activated?.id,
        })),
      }
    }

    case DELETE_LLM_SETTING:
      return {
        ...state,
        llmSettings: state.llmSettings.filter((s) => s.id !== action.payload),
      }

    default:
      return state
  }
}

export default llmSettingsReducer
